import { updateDesignParameter } from "../../../../Features/designParameter";
import {
  updateQuantityInfo,
  updateRoofDetails,
} from "../../../../Features/quantityInfo";
import {
  updatedAbstacles,
  updatedPolygonCoordinates,
} from "../../../../Features/roofInfo";
import { handlePanelRotation } from "../canvasFunction";
import { roofStructureData } from "../structureFunction";
import {
  handleCustomizedPanelRotation,
  handleCustomizePlacement,
} from "../structurePlacementFunction/customizeStructurePlacement";
import { SmithFlatPanelRotation } from "../structurePlacementFunction/smithStructure";
import { handleStructureClick } from "../structurePlacementFunction/structureCallFunction";

export const editRoof = ({ i, dispatch, designParameter, quantityInfo }) => {
  if (quantityInfo.roofNo === i) {
    dispatch(
      updateDesignParameter({
        polygonEdit: !designParameter.polygonEdit,
      })
    );
  } else {
    dispatch(
      updateDesignParameter({
        polygonEdit: true,
        lineNo: 0,
      })
    );
  }

  dispatch(updateQuantityInfo({ roofNo: i, allRoof: false }));
};

export const editObstacle = ({
  i,
  dispatch,
  designParameter,
  quantityInfo,
}) => {
  if (quantityInfo.abstacleNo === i) {
    dispatch(
      updateDesignParameter({
        abstacleEdit: !designParameter.abstacleEdit,
      })
    );
  } else {
    dispatch(
      updateDesignParameter({
        abstacleEdit: true,
        lineNo: 0,
      })
    );
  }

  dispatch(updateQuantityInfo({ abstacleNo: i, allRoof: false }));
};

export const nearToLine = ({
  i,
  updatePoints,
  quantityInfo,
  designParameter,
  gridInfo,
  roofInfo,
  dispatch,
  abstacles,
}) => {
  const roofIndex = quantityInfo.roofNo;
  const roofData = quantityInfo?.roofData || [];
  const roofDetail = roofData[roofIndex];

  if (roofDetail.mountingStructure === "Select") {
    alert("First of all select mounting structure");
    return false;
  }
  const arrayLength = updatePoints.length;
  const point1 = updatePoints[i];
  let point2;
  if (i === arrayLength - 1) {
    point2 = updatePoints[0];
  } else {
    point2 = updatePoints[i + 1];
  }

  const slope = (point2.y - point1.y) / (point2.x - point1.x);
  const angleInRadians = Math.atan(slope);
  var angleInDegrees = Number(((angleInRadians * 180) / Math.PI).toFixed());

  let structureItem = roofStructureData.find(
    (element) => element.name === roofDetail.mountingStructure
  );
  let changeAzimuth = angleInDegrees + 180;
  let rowDistance = roofDetail.rowDistance;
  dispatch(
    updateRoofDetails({
      index: roofIndex,
      fields: {
        azimuth: changeAzimuth,
      },
    })
  );

  dispatch(
    updateDesignParameter({
      xValue: 1,
      yValue: 1,
    })
  );

  if (changeAzimuth !== 180 && roofDetail.structureType !== "Multiple") {
    if (roofDetail.customizeStructure) {
      handleCustomizedPanelRotation({
        dispatch,
        abstacles,
        roofInfo,
        gridInfo,
        designParameter,
        quantityInfo,
        changeAzimuth,
      });
    } else {
      if (roofDetail.newStructure) {
        SmithFlatPanelRotation({
          dispatch,
          abstacles,
          roofInfo,
          gridInfo,
          structureItem,
          designParameter,
          quantityInfo,
          changeAzimuth,
        });
      } else {
        handlePanelRotation({
          dispatch,
          abstacles,
          roofInfo,
          gridInfo,
          structureItem,
          designParameter,
          quantityInfo,
          changeAzimuth,
        });
      }
    }
  } else {
    if (roofDetail.customizeStructure) {
      handleCustomizePlacement({
        roofInfo,
        dispatch,
        abstacles,
        roofDetail,
        quantityInfo,
        designParameter,
      });
    } else {
      handleStructureClick({
        structureItem,
        rowDistance,
        roofInfo,
        dispatch,
        abstacles,
        gridInfo,
        roofDetail,
        quantityInfo,
        designParameter,
      });
    }
  }
};

export const addNode = ({
  i,
  dispatch,
  quantityInfo,
  polygonIndex,
  roofPolygons,
  updatePoints,
}) => {
  if (quantityInfo.roofNo !== polygonIndex) return;
  const arrayLength = updatePoints.length;
  const index = i;
  const firstPoint = updatePoints[i];
  let secondPoint;
  if (i === arrayLength - 1) {
    secondPoint = updatePoints[0];
  } else {
    secondPoint = updatePoints[i + 1];
  }
  const specificPoint = {
    x: (firstPoint.x + secondPoint.x) / 2,
    y: (firstPoint.y + secondPoint.y) / 2,
  };
  let array = [...updatePoints];
  let changeArray = [];
  for (let j = 0; j < array.length; j++) {
    if (j === arrayLength - 1 && j === index - 1) {
      changeArray.push(array[j]);
      changeArray.push(specificPoint);
    } else if (j === index) {
      changeArray.push(array[j]);
      changeArray.push(specificPoint);
    } else {
      changeArray.push(array[j]);
    }
  }

  const updatedPolygon = [...roofPolygons];
  updatedPolygon[polygonIndex] = changeArray;

  dispatch(
    updatedPolygonCoordinates({
      index: polygonIndex,
      value: { updatedPoints: changeArray },
    })
  );
};

export const removeNode = ({
  i,
  dispatch,
  updatePoints,
  roofPolygons,
  polygonIndex,
}) => {
  if (updatePoints.length <= 3) {
    alert(
      "If the roof consists of three nodes, deletion or removal of any node is not permitted."
    );
    return false;
  }

  const point = updatePoints[i];
  const updatedPoints = updatePoints.filter((item) => item !== point);
  updatePoints = updatedPoints;
  const updatedPolygon = [...roofPolygons];
  updatedPolygon[polygonIndex] = updatedPoints;
  dispatch(
    updatedPolygonCoordinates({
      index: polygonIndex,
      value: { updatedPoints: updatedPoints },
    })
  );
};

export const addObstacleNode = ({
  i,
  dispatch,
  quantityInfo,
  polygonIndex,
  abstacles,
  updatePoints,
}) => {
  if (quantityInfo.abstacleNo !== polygonIndex) return;
  const arrayLength = updatePoints.length;
  const index = i;
  const firstPoint = updatePoints[i];
  let secondPoint;
  if (i === arrayLength - 1) {
    secondPoint = updatePoints[0];
  } else {
    secondPoint = updatePoints[i + 1];
  }
  const specificPoint = {
    x: (firstPoint.x + secondPoint.x) / 2,
    y: (firstPoint.y + secondPoint.y) / 2,
  };
  let array = [...updatePoints];
  let changeArray = [];
  for (let j = 0; j < array.length; j++) {
    if (j === arrayLength - 1 && j === index - 1) {
      changeArray.push(array[j]);
      changeArray.push(specificPoint);
    } else if (j === index) {
      changeArray.push(array[j]);
      changeArray.push(specificPoint);
    } else {
      changeArray.push(array[j]);
    }
  }

  const updatedPolygon = [...abstacles];
  updatedPolygon[polygonIndex] = changeArray;

  dispatch(
    updatedAbstacles({
      index: polygonIndex,
      value: { updatedPoints: changeArray },
    })
  );
};

export const removeObstacleNode = ({
  i,
  dispatch,
  updatePoints,
  abstacles,
  polygonIndex,
}) => {
  if (updatePoints.length <= 3) {
    alert(
      "If the obstacle consists of three nodes, deletion or removal of any node is not permitted."
    );
    return false;
  }

  const point = updatePoints[i];
  const updatedPoints = updatePoints.filter((item) => item !== point);
  updatePoints = updatedPoints;
  const updatedPolygon = [...abstacles];
  updatedPolygon[polygonIndex] = updatedPoints;
  dispatch(
    updatedAbstacles({
      index: polygonIndex,
      value: { updatedPoints: updatedPoints },
    })
  );
};

export const structureAlignUsingKey = ({
  e,
  dispatch,
  designParameter,
  roofInfo,
  quantityInfo,
  gridInfo,
}) => {
  console.log(designParameter.xValue, designParameter.yValue);
  const x = designParameter.xValue ?? 1;
  const y = designParameter.yValue ?? 1;
  console.log(x, y);
  if (e.key === "ArrowUp") {
    dispatch(updateDesignParameter({ yValue: y - 1 }));
  } else if (e.key === "ArrowDown") {
    dispatch(updateDesignParameter({ yValue: y + 1 }));
  } else if (e.key === "ArrowLeft") {
    dispatch(updateDesignParameter({ xValue: x - 1 }));
  } else if (e.key === "ArrowRight") {
    dispatch(updateDesignParameter({ xValue: x + 1 }));
  }

  const roofIndex = quantityInfo.roofNo;
  const roofData = quantityInfo?.roofData || [];
  const roofDetail = roofData[roofIndex];
  const changeAzimuth = roofDetail.azimuth;

  let structureItem = roofStructureData.find(
    (element) => element.name === roofDetail.mountingStructure
  );
  const abstacles = roofInfo?.value?.abstacles || [];

  if (roofDetail.customizeStructure) {
    handleCustomizedPanelRotation({
      dispatch,
      abstacles,
      roofInfo,
      gridInfo,
      designParameter,
      quantityInfo,
      changeAzimuth,
    });
  } else {
    if (roofDetail.newStructure) {
      SmithFlatPanelRotation({
        dispatch,
        abstacles,
        roofInfo,
        gridInfo,
        structureItem,
        designParameter,
        quantityInfo,
        changeAzimuth,
      });
    } else {
      handlePanelRotation({
        dispatch,
        abstacles,
        roofInfo,
        gridInfo,
        structureItem,
        designParameter,
        quantityInfo,
        changeAzimuth,
      });
    }
  }
};
